import React from "react";

import { CancelOutlined, CheckCircleOutline } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";

import { AdminCreateDynamicGroupRequest } from "@safetyculture/s12-apis-connect-web/s12/groups/admin/v1/admin_groups_pb";

import { CreateResponse } from "./types";

type UploaderProps = {
  requests: Record<string, AdminCreateDynamicGroupRequest>;
  responses: Record<string, CreateResponse>;
};

export const Uploader = (props: UploaderProps) => {
  const theme = useTheme();
  return (
    <Box
      height={400}
      sx={{
        overflowY: "auto",
        borderRadius: 2,
        border: "1px solid #999",
      }}
    >
      {Object.entries(props.requests).map(([key, request], index) => (
        <Grid
          key={key}
          container
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          px={2}
          py={0.5}
          wrap="nowrap"
          width="100%"
          bgcolor={
            index % 2 === 0
              ? theme.palette.background.paper
              : theme.palette.background.default
          }
        >
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
            }}
          >
            <Typography
              variant="body1"
              noWrap
              sx={{ textOverflow: "ellipsis", overflow: "hidden" }}
            >
              {request.name}
            </Typography>
          </Box>

          <Box sx={{ flexShrink: 0, pl: 2 }}>
            {props.responses[key] ? (
              props.responses[key].success ? (
                <CheckCircleOutline color="success" />
              ) : (
                <CancelOutlined color="error" />
              )
            ) : (
              <CircularProgress
                color="primary"
                variant="indeterminate"
                thickness={4}
                size={20}
              />
            )}
          </Box>
        </Grid>
      ))}
    </Box>
  );
};
